import { Link } from "react-router-dom";
import { faqs, testimonials, site } from "@/mocks/content";

const values = [
  { icon: "ri-scales-3-fill", t: "理性吃瓜", d: "先核实，再发声，不信谣不传谣。" },
  { icon: "ri-quill-pen-fill", t: "深挖到底", d: "不满足于结论，还原事件来龙去脉。" },
  { icon: "ri-heart-fill", t: "尊重原创", d: "保护信源，尊重每一位内容创作者。" },
];

function FaqTeaser() {
  const top2 = faqs.slice(0, 2);
  return (
    <div className="rounded-2xl border border-background-200 bg-background-50 p-6">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-900">
          <i className="ri-question-line text-primary-600" />
          高频问题
        </h3>
        <Link
          to="/faq"
          className="text-sm font-medium text-primary-600 hover:text-primary-700"
        >
          查看全部 FAQ
        </Link>
      </div>
      <div className="space-y-3">
        {top2.map((f) => (
          <details key={f.q} className="group rounded-xl bg-background-100/70 p-4">
            <summary className="flex cursor-pointer list-none items-center justify-between gap-3 text-sm font-semibold text-foreground-900">
              {f.q}
              <i className="ri-add-line shrink-0 text-foreground-500 transition-transform group-open:rotate-45" />
            </summary>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              {f.a}
            </p>
          </details>
        ))}
      </div>
    </div>
  );
}

export default function AboutBand() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
      <div className="grid gap-6 lg:grid-cols-2">
        {/* 品牌口碑 */}
        <div className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-6 md:p-8">
          <p className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-accent-600">
            <span className="inline-block h-3 w-1 rounded-full bg-accent-500" />
            Our Voice
          </p>
          <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-900 md:text-3xl">
            瓜友怎么说
          </h2>
          <div className="mt-5 space-y-4">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="rounded-xl bg-background-100/70 p-4"
              >
                <i className="ri-double-quotes-l text-primary-300" />
                <blockquote className="mt-1 text-sm leading-relaxed text-foreground-700">
                  “{t.text}”
                </blockquote>
                <figcaption className="mt-3 flex items-center gap-2 text-xs text-foreground-500">
                  <span className="flex h-7 w-7 items-center justify-center rounded-full bg-accent-200 text-accent-800">
                    <i className="ri-user-smile-fill" />
                  </span>
                  <span className="font-medium text-foreground-800">
                    {t.name}
                  </span>
                  <span>· {t.role}</span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>

        {/* 理念 + FAQ */}
        <div className="flex flex-col gap-6">
          <div className="rounded-2xl border border-background-200 bg-primary-50/60 p-6 md:p-8">
            <h3 className="font-heading text-lg font-bold text-foreground-900">
              {site.name}，凭什么敢称独家？
            </h3>
            <div className="mt-4 space-y-3">
              {values.map((v) => (
                <div key={v.t} className="flex items-start gap-3">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-600 text-background-50">
                    <i className={v.icon} />
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">
                      {v.t}
                    </p>
                    <p className="text-sm text-foreground-600">{v.d}</p>
                  </div>
                </div>
              ))}
            </div>
            <Link
              to="/about"
              className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700 hover:text-primary-800"
            >
              了解我们的内容原则
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
          <FaqTeaser />
        </div>
      </div>
    </section>
  );
}